import { BackrsUser } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { PlaylistCard, PlaylistCardProps } from './PlaylistCard';

const PLAYLIST_EMPTY_STATE_SECTION_STRINGS =
  appStrings.modules.priorities.playlistsSection.emptyState;

type PlaylistSectionEmptyStateProps = Readonly<{
  openNewPlaylistDialog: (preLoadedTitle?: string) => void;
  currentUser?: BackrsUser;
}>;

export const PlaylistSectionEmptyState = ({
  openNewPlaylistDialog,
  currentUser,
}: PlaylistSectionEmptyStateProps) => {
  const basePlaylistParams = {
    id: 0,
    description: '',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    user_id: currentUser?.id || null,
    user: currentUser,
    created_by: currentUser?.id || null,
  };

  const emptyStatePlaylists: PlaylistCardProps[] = [
    {
      id: 'playlist-empty-state-build-card',
      playlist: {
        ...basePlaylistParams,
        title: PLAYLIST_EMPTY_STATE_SECTION_STRINGS.buildPlaylist.title,
        total_tasks: 0,
        completed_tasks: 0,
      },
      onClick: () => openNewPlaylistDialog(),
    },
    {
      id: 'playlist-empty-state-college-shortlist-card',
      playlist: {
        ...basePlaylistParams,
        id: 1,
        title: PLAYLIST_EMPTY_STATE_SECTION_STRINGS.collegeShortlist.title,
        total_tasks: 1,
        completed_tasks: 0,
        user_id: 0,
      },
      onClick: () =>
        openNewPlaylistDialog(PLAYLIST_EMPTY_STATE_SECTION_STRINGS.collegeShortlist.title),
      opacity: 0.5,
    },
    {
      id: 'playlist-empty-state-scholarships-card',
      playlist: {
        ...basePlaylistParams,
        id: 2,
        title: PLAYLIST_EMPTY_STATE_SECTION_STRINGS.scholarshipOpportunities.title,
        total_tasks: 1,
        completed_tasks: 0,
        user_id: 0,
      },
      onClick: () =>
        openNewPlaylistDialog(PLAYLIST_EMPTY_STATE_SECTION_STRINGS.scholarshipOpportunities.title),
      opacity: 0.5,
    },
  ];

  return (
    <>
      {emptyStatePlaylists.map((cardProps) => (
        <PlaylistCard key={cardProps.id} {...cardProps} />
      ))}
    </>
  );
};
